import { ReactText } from 'react';

import { Lens } from 'monocle-ts';

import { CartItem } from '@domains/cart';

import { rootDomain } from '@stores/root';

import { applyLensPayload } from '@utils/lens';

export type OutProductsDialogState = {
    isOpen: boolean;
    options: {
        items: CartItem[];
        onApply(): void;
        buttonText: ReactText;
        isLoading?: boolean;
        isClosable?: boolean;
    };
};

const outProductsDialogDomain = rootDomain.createDomain();

// --- Events ---
export const resetOutProductsDialog = outProductsDialogDomain.createEvent();
export const setOutProductsDialog = outProductsDialogDomain.createEvent<OutProductsDialogState>();
export const setOutProductsDialogLoading = outProductsDialogDomain.createEvent<boolean>();

// --- Lens ---
export const outProductsDialogLoadingLens = Lens.fromPath<OutProductsDialogState>()([
    'options',
    'isLoading',
]);

const outProductsDialogInitialState: OutProductsDialogState = {
    isOpen: false,
    options: {
        items: [],
        onApply: () => resetOutProductsDialog(),
        buttonText: 'Close',
        isLoading: false,
        isClosable: true,
    },
};

export const $outProductsDialog = outProductsDialogDomain
    .createStore<OutProductsDialogState>(outProductsDialogInitialState, {
        name: 'out-products-dialogs',
    })
    .on(setOutProductsDialog, (_, payload) => payload)
    .on(setOutProductsDialogLoading, applyLensPayload(outProductsDialogLoadingLens))
    .reset(resetOutProductsDialog);
